import React from 'react'
import {
    AnalyticsTabs,FlexyRow,FlexyRowJustify
  } from '../home.style';
import Cookies from 'js-cookie';
import copy from 'clipboard-copy';
import { toaster } from 'evergreen-ui';
import { gql, useQuery,
} from '@apollo/client';
import AddAssetsPlaceholder from '../../../../../widget/add_assets_placeholder';
import { formatAmount, getCurrentMonth } from '../../../../../widget/util';


export const FETCH_DATA= gql`
query Facility_getDashboardData($facilityId: ID!, $duesTimelimit: Date!) {
  facility_getDashboardData(facilityId: $facilityId, duesTimelimit: $duesTimelimit) {
    propertyCount
    paidDuesAmount
    pendingDuesAmount
    code
  }
}

`;

function AnalyticsWidget() {
const facilityCode = Cookies.get('facilityCode');

const facilityId = Cookies.get('facilityId');

const { loading,error,data }  = useQuery(FETCH_DATA,{
  variables:{
    facilityId,
    duesTimelimit:"2024-12-31"
  }
});

console.log("fac",facilityId)

if(facilityId === undefined)return <center> <AddAssetsPlaceholder/></center>
if (loading) return <AnalyticsLoader/>;
if (error) return <p>Error: {error.message}</p>;
const dashboardData = data.facility_getDashboardData


const handleCopyClick = async () => {
  try {
    await copy(facilityCode);
  toaster.success('Text copied to clipboard: ' + facilityCode);
  } catch (err) {
    toaster.danger("An error occured.")
    console.error('Failed to copy text: ', err);
  }
};
  return (
    <div className='row'>
      {facilityId === undefined
        ? <center> <AddAssetsPlaceholder/></center>
        :<FlexyRow>
          
          <AnalyticsTabs>
            <h5>ESTATE CODE</h5>
            <FlexyRowJustify>
              <h6 className='value'>{dashboardData.code}</h6>
              <button className='btn-flat btn transparent' onClick={handleCopyClick}>
                <h6  >
                  <i className='material-icons'>content_copy</i>
                </h6>
              </button>
              
            </FlexyRowJustify>   
          </AnalyticsTabs>

          <AnalyticsTabs>
            <h5>TOTAL DUES COLLECTED </h5>
            <FlexyRowJustify>
              <h6 className='value'>
                N{formatAmount(parseFloat(dashboardData.paidDuesAmount))}
              </h6>
              <h6 style={{
                color:"#22C55E"
              }}>
                {/* JUNE */}
                {getCurrentMonth()}
              </h6>
            </FlexyRowJustify>   
          </AnalyticsTabs>

          <AnalyticsTabs>
            <h5>TOTAL DUES PENDING</h5>
            <FlexyRowJustify>
              <h6 className='value'>
                N{formatAmount(parseFloat(dashboardData.pendingDuesAmount))}
              </h6>
              <h6 style={{
                color:"#EF4444"
              }}>
              {/* JUNE */}
              {getCurrentMonth()}
              </h6>
            </FlexyRowJustify>   
          </AnalyticsTabs>

          <AnalyticsTabs>
            <h5>PROPERTIES</h5>
            <FlexyRowJustify>
              <h6 className='value'>{dashboardData.propertyCount}</h6>
              <h6 style={{
                color:"#4F46E5"

              }}>
              IN ESTATE
              </h6>
            </FlexyRowJustify>   
          </AnalyticsTabs>

         
        </FlexyRow>
      }

    </div>
  )
}

export default AnalyticsWidget





 function AnalyticsLoader() {
  return (
    <div className='row'>
    <FlexyRow>
      
      <AnalyticsTabs>
        <h5>ESTATE CODE</h5>
        <FlexyRowJustify>
          <h6 className='value'>---</h6>
          <button className='btn-flat btn transparent' >
            <h6  >
              <i className='material-icons'>content_copy</i>
            </h6>
          </button>
          
        </FlexyRowJustify>   
      </AnalyticsTabs>

      <AnalyticsTabs>
        <h5>TOTAL DUES COLLECTED </h5>
        <FlexyRowJustify>
          <h6 className='value'>---</h6>
          <h6 style={{
            color:"#22C55E"
          }}>
            JUNE
          </h6>
        </FlexyRowJustify>   
      </AnalyticsTabs>

      <AnalyticsTabs>
        <h5>TOTAL PENDING</h5>
        <FlexyRowJustify>
          <h6 className='value'>---</h6>
          <h6 style={{
            color:"#EF4444"
          }}>
          JUNE
          </h6>
        </FlexyRowJustify>   
      </AnalyticsTabs>

      <AnalyticsTabs>
        <h5>PROPERTIES</h5>
        <FlexyRowJustify>
          <h6 className='value'>---</h6>
          <h6 style={{
            color:"#4F46E5"

          }}>
          IN ESTATE
          </h6>
        </FlexyRowJustify>   
      </AnalyticsTabs>

     
    </FlexyRow>
  </div>
  )
}
